module.exports = __webpack_public_path__ + "img/bg_12.aa601303.png";